import React from 'react';
import { QUIZ } from '../../Pages';
import { CONTENT_TYPES } from '../../../core/constants';

export default {
  path: QUIZ.pageURL,
  async action() {
    const { default: CommonManager } =
      await import('../common/ContentManagerView/CommonManager');
    return (
      <CommonManager
        key={'list'}
        contentType={CONTENT_TYPES.QUIZ}
        page={QUIZ}
      />
    );
  },
};
